import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Card, CardContent, Grid, Button, CircularProgress, Alert, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const PatientDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [dashboard, setDashboard] = useState({ upcomingAppointments: [], latestReports: [] });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboard = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await axios.get(`${API_URL}/api/patients/me/dashboard`);
        setDashboard(res.data);
      } catch (err) {
        setError('Failed to load dashboard');
      } finally {
        setLoading(false);
      }
    };
    fetchDashboard();
  }, []);

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}><CircularProgress /></Box>;
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>Patient Dashboard</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>Upcoming Appointments</Typography>
              {dashboard.upcomingAppointments.length === 0 ? (
                <Typography color="text.secondary">No upcoming appointments</Typography>
              ) : (
                dashboard.upcomingAppointments.map(app => (
                  <Box key={app.id} sx={{ mb: 2 }}>
                    <Typography><strong>Date:</strong> {new Date(app.appointmentTime).toLocaleString()}</Typography>
                    <Typography><strong>Status:</strong> {app.status}</Typography>
                    <Typography><strong>Tests:</strong> {app.tests.map(t => t.name).join(', ')}</Typography>
                    <Button size="small" sx={{ mt: 1 }} onClick={() => navigate(`/patient-appointments/${app.id}`)}>View Details</Button>
                    <Divider sx={{ my: 1 }} />
                  </Box>
                ))
              )}
              <Button fullWidth variant="outlined" sx={{ mt: 2 }} onClick={() => navigate('/patient-appointments')}>View All Appointments</Button>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>Latest Reports</Typography>
              {dashboard.latestReports.length === 0 ? (
                <Typography color="text.secondary">No recent reports</Typography>
              ) : (
                dashboard.latestReports.map(report => (
                  <Box key={report.id} sx={{ mb: 2 }}>
                    <Typography><strong>Date:</strong> {new Date(report.date).toLocaleString()}</Typography>
                    <Typography><strong>Status:</strong> {report.status}</Typography>
                    <Button size="small" sx={{ mt: 1 }} onClick={() => navigate(`/patient-reports/${report.id}`)}>View Report</Button>
                    <Divider sx={{ my: 1 }} />
                  </Box>
                ))
              )}
              <Button fullWidth variant="outlined" sx={{ mt: 2 }} onClick={() => navigate('/patient-reports')}>View All Reports</Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PatientDashboard; 